module.exports = __webpack_public_path__ + "public/SiteIcons/exitpageIconThree.svg?612f2143";